import { SearchPage } from 'Components'
import TemplateSearchPage from 'Stores/shopify-dawn-generic/Templates/SearchPage.rt'
import { FacetTiles } from 'Components'
import TemplatefacetTilessubtitles from 'Stores/_default-store/Templates/facetTiles/subtitles.rt'
import { FacetPanel } from 'Components'
import { SearchResult } from 'Components'
import { SearchHeader } from 'Components'
import { SearchBox } from 'Components'
import TemplateSearchBox from 'Stores/_default-store/Templates/SearchBox.rt'
import { SearchBoxDialogButton } from 'Components'
import TemplatesearchBoxdialogButtonMobile from 'Stores/_default-store/Templates/searchBox/dialogButtonMobile.rt'
import { VehicleWidget } from 'Components'
import TemplatefitmentSearchcollapsibleVehicleWidget from 'Stores/_default-store/Templates/fitmentSearch/collapsibleVehicleWidget.rt'
import { Garage } from 'Components'
import TemplatefitmentSearchgarage from 'Stores/_default-store/Templates/fitmentSearch/garage.rt'
import { SingleVehicleGarage } from 'Components'
import TemplatefitmentSearchsingleVehicleGarage from 'Stores/_default-store/Templates/fitmentSearch/singleVehicleGarage.rt'
import { VerifyFitment } from 'Components'
import TemplatefitmentSearchcollapsibleVerifyFitment from 'Stores/_default-store/Templates/fitmentSearch/collapsibleVerifyFitment.rt'
import { FitmentTable } from 'Components'
import TemplatefitmentSearchfitmentTable from 'Stores/_default-store/Templates/fitmentSearch/fitmentTable.rt'
import TemplatefacetTileshierarchicalContainer from 'Stores/_default-store/Templates/facetTiles/hierarchicalContainer.rt'
import TemplatefacetTilesalphabeticalContainer from 'Stores/_default-store/Templates/facetTiles/alphabeticalContainer.rt'
import { RelatedItems } from 'Components'
import TemplateproductrelatedItems from 'Stores/_default-store/Templates/product/relatedItems.rt'
import { BuyItemsTogether } from 'Components'
import TemplateproductboughtTogether from 'Stores/_default-store/Templates/product/boughtTogether.rt'
import { FacetDialog } from 'Components'
import TemplateFacetDialogVehicleSpecs from 'Stores/shopify-dawn-generic/Templates/FacetDialogVehicleSpecs.rt'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import { VehicleWidgetDialog } from 'Components'
import TemplatefitmentSearchdialog from 'Stores/_default-store/Templates/fitmentSearch/dialog.rt'
import { AutoSyncVisualizationDialog } from 'Components'
import TemplatefitmentSearchautoSyncVisualizationDialog from 'Stores/_default-store/Templates/fitmentSearch/autoSyncVisualizationDialog.rt'
import { FacetBar } from 'Components'
import { WheelTireVehicleInfo } from 'Components'
import TemplatefitmentSearchhomeVehicleWidget from 'Stores/_default-store/Templates/fitmentSearch/homeVehicleWidget.rt'
import { RequestPanel } from 'Components'
import TemplateHomeWheelTireBar from 'Stores/_default-store/Templates/HomeWheelTireBar.rt'

export const compMap = {
  SearchPage,
FacetTiles,
FacetPanel,
SearchResult,
SearchHeader,
SearchBox,
SearchBoxDialogButton,
VehicleWidget,
Garage,
SingleVehicleGarage,
VerifyFitment,
FitmentTable,
RelatedItems,
BuyItemsTogether,
FacetDialog,
SearchBoxDialog,
VehicleWidgetDialog,
AutoSyncVisualizationDialog,
FacetBar,
WheelTireVehicleInfo,
RequestPanel
}
export const tplMap = {
  'SearchPage': TemplateSearchPage,
'facetTiles/subtitles': TemplatefacetTilessubtitles,
'SearchBox': TemplateSearchBox,
'searchBox/dialogButtonMobile': TemplatesearchBoxdialogButtonMobile,
'fitmentSearch/collapsibleVehicleWidget': TemplatefitmentSearchcollapsibleVehicleWidget,
'fitmentSearch/garage': TemplatefitmentSearchgarage,
'fitmentSearch/singleVehicleGarage': TemplatefitmentSearchsingleVehicleGarage,
'fitmentSearch/collapsibleVerifyFitment': TemplatefitmentSearchcollapsibleVerifyFitment,
'fitmentSearch/fitmentTable': TemplatefitmentSearchfitmentTable,
'facetTiles/hierarchicalContainer': TemplatefacetTileshierarchicalContainer,
'facetTiles/alphabeticalContainer': TemplatefacetTilesalphabeticalContainer,
'product/relatedItems': TemplateproductrelatedItems,
'product/boughtTogether': TemplateproductboughtTogether,
'FacetDialogVehicleSpecs': TemplateFacetDialogVehicleSpecs,
'SearchBoxDialog': TemplateSearchBoxDialog,
'fitmentSearch/dialog': TemplatefitmentSearchdialog,
'fitmentSearch/autoSyncVisualizationDialog': TemplatefitmentSearchautoSyncVisualizationDialog,
'fitmentSearch/homeVehicleWidget': TemplatefitmentSearchhomeVehicleWidget,
'HomeWheelTireBar': TemplateHomeWheelTireBar
};